import { render, staticRenderFns } from "./commissionSettings.vue?vue&type=template&id=368bcfa0&scoped=true"
import script from "./commissionSettings.vue?vue&type=script&lang=js"
export * from "./commissionSettings.vue?vue&type=script&lang=js"
import style0 from "./commissionSettings.vue?vue&type=style&index=0&id=368bcfa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368bcfa0",
  null
  
)

export default component.exports